module.exports = __webpack_public_path__ + "static/media/safety-purple.875997dd.svg";